import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { useHistory } from 'react-router-dom';
import { useAppState } from '../../core/redux/hooks';
import { useDispatch } from 'react-redux';
import { raterApprovalParticipantsAction } from '../../raterApproval/api/raterApprovalParticipantsAction';
import { useMount } from '../../core/hooks/useMount';
import { useRoutes } from '../../navigation/routes';
import { useLoading } from '../../core/api/hooks';
import { ActionType } from '../../core/redux/actionType';
import { Spinner } from '../../loading/Spinner';
import { COLORS } from '../../globalStyle/colors';
import { css } from '@emotion/core';
import { Z_INDEX } from '../../globalStyle/zIndex';


const styles = {
  root:    css`
    position: fixed;
    z-index: ${Z_INDEX.MODAL};

    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;

    display: flex;
    align-items: center;
    justify-content: center;

    background-color: rgba(0, 0, 0, 0.8);
    cursor: pointer;
    opacity: 0;
  `,
  spinner: css`
    width: 100px;
    height: 100px;
  `,
};


/**
 * RaterApprovalRedirect: a component that fetches data for the rater approval flow before loading its respective UI.
 *
 * Shows a loading screen while data is being retrieved.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const RaterApprovalRedirect: React.FC = () => {
  const dispatch     = useDispatch();
  const history      = useHistory();
  const approverId   = useAppState(state => state.auth.currentUser?.personId!);
  const participants = useAppState(state => state.raterApprovalParticipants);

  useMount(() => {
    if (!participants) {
      dispatch(raterApprovalParticipantsAction(approverId));
    }
  });

  const isLoading = useLoading(ActionType.RaterApprovalParticipantsRequest, `${approverId}`);

  const participant   = React.useMemo(() => participants?.[0], [participants]);
  const participantId = React.useMemo(() => +(participant?.participantId ?? '-1'), [participant]);
  const projectId     = React.useMemo(() => (participant?.displayProjectId ?? '-'), [participant]);

  const routes = useRoutes(participantId, projectId);

  if (!!participants) {
    history.replace(routes.RaterApprovalDashboard);
  }

  return (!participants || isLoading)
    ? (
      ReactDOM.createPortal(
        <div css={styles.root}>
          <Spinner fill={COLORS.GREEN} css={styles.spinner} />
        </div>,
        document.body,
      )
    ) : null;
};

export default RaterApprovalRedirect;